import WebFont from "webfontloader";

const DEFAULT_FONT_WEIGHTS = '300;400;500;600;700';

const buildFontCss = ({ base, alt } = {}) => {
    let css = ':root {';
    if (base) {
        css += `--font-family-base: ${base};`;
    }
    if (alt) {
        css += `--font-family-alt: ${alt};`;
    }
    css += '}';
    return css;
};

const toGoogleFamilies = (names) => {
    return (names || [])
        .filter(name => !!name)
        .map(name => `${name}:wght@${DEFAULT_FONT_WEIGHTS}&display=swap`);
};

const setFontsInDom = ({ base, alt } = {}) => {
    const css = buildFontCss({ base, alt });

    const styleElement = document.getElementById('dialogue-theme-fonts');
    if ( styleElement ) {
        styleElement.innerHTML = css;
    } else {
        const style = document.createElement('style');
        style.id = 'dialogue-theme-fonts';
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
    }
};

const loadSelectedFonts = (themeSettings) => {
    const base = themeSettings?.typography?.bodyFont;
    const alt = themeSettings?.typography?.headingFont;

    // Always (re)write the style block so that resetting to "Theme default"
    // clears any previously-injected override and restores each theme's own
    // var() fallback. setFontsInDom emits an empty :root{} when nothing is set.
    setFontsInDom({ base, alt });

    const families = toGoogleFamilies([base, alt]);
    if (families.length) {
        WebFont.load({
            google: {
                families
            }
        });
    }
};

export {
    buildFontCss,
    toGoogleFamilies,
    setFontsInDom,
    loadSelectedFonts
};
